module.exports = __webpack_public_path__ + "img/2.6e551e66.jpeg";